import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertComponent} from "./alert.component";
import { DashboardService } from 'app/services/dashboard.service';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
    declarations: [AlertComponent],
    imports: [
        CommonModule,
        MatIconModule
    ],
    exports: [AlertComponent],
    providers:[DashboardService]
})
export class AlertModule {
}
